// Hand-off state that must survive a route change but not a reload.

/** conversationId → { text, attachments } — the first question typed on /new. */
const pendingQuestions = new Map()

/** Conversations created optimistically in this tab (no server row yet). */
const optimisticConversations = new Set()

export function queueQuestion(conversationId, text, attachments = []) {
  pendingQuestions.set(conversationId, { text, attachments })
  optimisticConversations.add(conversationId)
}

export function peekQuestion(conversationId) {
  return pendingQuestions.get(conversationId) ?? null
}

export function takeQuestion(conversationId) {
  const pending = pendingQuestions.get(conversationId) ?? null
  pendingQuestions.delete(conversationId)
  return pending
}

export function isOptimisticConversation(conversationId) {
  return optimisticConversations.has(conversationId)
}

export function settleConversation(conversationId) {
  optimisticConversations.delete(conversationId)
}

/** Composer pre-fill when a page asks for a question about given systems. */
let draftForNew = null

export function setNewQuestionDraft(draft) {
  draftForNew = draft
}

export function takeNewQuestionDraft() {
  const draft = draftForNew
  draftForNew = null
  return draft
}
